import { RefObject, useEffect, useState } from "react";

import { configStyle } from "@/components/CityLocation/config/config";

interface GoogleMapsHook {
  map: google.maps.Map | undefined;
  mapRendered: boolean;
  setScriptLoaded: Function;
}

const useGoogleMap = (
  mapContainerReference: RefObject<HTMLDivElement>,
  center = { lat: 25.136731074279453, lng: 55.340319557234146 },
  zoom = 13,
  mapOptions: google.maps.MapOptions = {},
): GoogleMapsHook => {
  const [map, setMap] = useState<google.maps.Map>();
  const [mapRendered, setMapRendered] = useState<boolean>(false);
  const [scriptLoaded, setScriptLoaded] = useState<boolean>(false);
  useEffect(() => {
    if (typeof window !== undefined) {
      const intervalId = setInterval(() => {
        if (window?.google?.maps) {
          setScriptLoaded(true);
          clearInterval(intervalId);
        }
      }, 500);
      return () => clearInterval(intervalId);
    }
    const intervalId = setInterval(() => {
      if (window?.google?.maps) {
        setScriptLoaded(true);
        clearInterval(intervalId);
      }
    }, 500);
    return () => clearInterval(intervalId);
  }, []);
  useEffect(() => {
    if (mapContainerReference?.current && scriptLoaded && !map && window.google?.maps?.MapTypeId) {
      const newMap = new window.google.maps.Map(mapContainerReference.current, {
        center: center,
        mapId: `${process.env.NEXT_PUBLIC_GOOGLE_MAP_ID}`,
        fullscreenControl: false,
        zoom: zoom,
        keyboardShortcuts: false,
        styles: configStyle,
        clickableIcons: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: true,
        gestureHandling: "greedy",
        ...mapOptions,
      });
      google.maps.event.addListenerOnce(newMap, "idle", () => {
        setMapRendered(true);
      });
      setMap(newMap);
    }
  }, [mapContainerReference, scriptLoaded, center, zoom, mapOptions, map]);
  return { map, mapRendered, setScriptLoaded };
};

export default useGoogleMap;
